import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 12h3","key":"svg-1"}],["path",{"d":"M14 8h-4v8","key":"svg-2"}]]

const IconCircleLetterF = createReactComponent('outline', 'circle-letter-f', 'CircleLetterF', __iconNode);

export default IconCircleLetterF;